import { useQuery } from "@tanstack/react-query";
import { get } from "~/Services/Request";

export const useEnumData = (enumName: string) => {
    return useQuery({
        queryKey: [`/admin/Enums?typeName=${enumName}`],
        queryFn: () => {
            return get<EnumModel[]>(`/admin/Enums?typeName=${enumName}`);
        },
        select: data => {
            return data;
        },
    });
};
export interface EnumModel {
    label: string;
    value: string;
}
